import { DeleteOutlined, QuestionCircleOutlined } from "@ant-design/icons"
import { Button, Card, Col, ConfigProvider, Input, Row } from "antd"
import { useContext, useState } from "react"
import { useNavigate } from "react-router-dom";
import Label_language from '../language'

const { ConfigContext } = ConfigProvider;
const label_language = Label_language
const ButtonDisabledStyle = {
    fontSize: '1.5rem',
    height: '9rem',
    width: '9rem',
    whiteSpace: 'break-spaces',
    border: '3px solid #e5e5e5',
}
const ButtonStyle = {
    fontSize: '1.5rem',
    height: '9rem',
    width: '9rem',
    whiteSpace: 'break-spaces',
    border: '3px solid #FBBDA5',
}

/* 
    {
        title_text: "123",
        children: [
            {
                page: 'accounts_receivable'
            },
        ]
    },
    {
        title_text: "456",
        children: [
            {
                page: 'accounts_payable'
            },
        ]
    },
*/
const Card_ot_permission_group = (props) => {
    const navigate = useNavigate();
    const configContext = useContext(ConfigContext)
    return (<>
        <Card
            title={props.title_text !== null && (<>
                <Row gutter={16}>
                    <Col flex='auto'
                        style={{
                            fontSize: '1.6rem'

                        }}>{props.title_text !== 'undefined' ? (<>
                            {props.custom_menu ? (<>
                                <Input
                                    value={props.title_text}
                                    onChange={({ target }) => props.handle_on_change_title_text(target.value)}
                                />
                            </>) :
                                props.title_text
                            }
                        </>)
                            :
                            label_language.utility.children.undefined[configContext.locale.locale]
                        }
                    </Col>
                    {props.on_delete && (<>
                        <Col
                            style={{
                                fontSize: '1.5rem'

                            }}>
                            <DeleteOutlined
                                onClick={props.on_delete}
                            />
                        </Col>
                    </>)}
                </Row>
            </>)}
            headStyle={{
                backgroundColor: '#fff3dd',
                color: '#575757',
            }}
            {...props}
        >
            <Row gutter={[24, 24]} wrap>
                {props.pages.map(([page, item], map_index) =>
                    typeof item === 'object' &&
                    <Col
                        key={page}
                        onDragOver={() => props.set_cur_over_index(map_index)}
                    >
                        <Button
                            disabled={props.disabled ?? false}
                            draggable={props.custom_menu}
                            onDragStart={() => {
                                props.set_cur_page(page)
                            }}
                            onDragEnd={() => {
                                props.set_cur_page('')
                                props.handle_on_drag_end()
                            }}
                            type={'text'}
                            style={{
                                fontSize: '1.5rem',
                                height: '9rem',
                                width: '9rem',
                                whiteSpace: 'break-spaces',
                                border: props.disabled ? '3px solid #e5e5e5' : '3px solid #FBBDA5',
                            }}
                            onClick={() => !props.custom_menu && navigate(`./${page}`)}
                        >
                            <Row
                                style={{
                                    height: '50%'
                                }}
                            >
                                <Col flex='auto'
                                    style={{
                                        fontSize: 'xxx-large',
                                        textAlign: 'center'
                                    }}
                                >
                                    {item.icon && item.icon}
                                    {!item.icon && <QuestionCircleOutlined
                                        style={{
                                            color: props.disabled ? "#BAA89B" : '#E17044',
                                            textAlign: 'center'
                                        }}
                                    />}
                                </Col>
                            </Row>
                            <Row
                                style={{
                                    height: '50%',
                                    textAlign: 'center',
                                    justifyContent: 'center',
                                    color: props.disabled ? "#BAA89B" : "#545D78",
                                    // color: '#545D78',
                                    fontWeight: 'bold'
                                }}
                            >
                                {item[configContext.locale.locale]}
                            </Row>
                        </Button>
                    </Col>
                )}
            </Row>
        </Card>
    </>)
}
export default Card_ot_permission_group;